import { render, staticRenderFns } from "./FamilyDetailModal.vue?vue&type=template&id=6b02f9f9&scoped=true&lang=pug"
import script from "./FamilyDetailModal.vue?vue&type=script&lang=ts"
export * from "./FamilyDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./FamilyDetailModal.vue?vue&type=style&index=0&id=6b02f9f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b02f9f9",
  null
  
)

export default component.exports